import { ApiService } from '@/services/api/ApiService';
import { GenieBranding } from '@/types/ui/branding';

export class AccountBrandingService {
  /**
   * Get account branding for a team via API
   */
  static async getAccountBranding(teamId: number): Promise<GenieBranding | null> {
    try {
      const response = await ApiService.invoke({
        resource: 'teams',
        action: 'get-branding',
        id: teamId,
      });

      return response?.branding || null;
    } catch (error) {
      console.error('Error fetching account branding:', error);
      throw error;
    }
  }

  /**
   * Update account branding for a team via API
   */
  static async updateAccountBranding(
    teamId: number,
    branding: GenieBranding
  ): Promise<void> {
    try {
      await ApiService.invoke({
        resource: 'teams',
        action: 'update-branding',
        id: teamId,
        data: { branding },
      });
    } catch (error) {
      console.error('Error updating account branding:', error);
      throw error;
    }
  }

  /**
   * Clear account branding for a team via API
   */
  static async clearAccountBranding(teamId: number): Promise<void> {
    try {
      await ApiService.invoke({
        resource: 'teams',
        action: 'clear-branding',
        id: teamId,
      });
    } catch (error) {
      console.error('Error clearing account branding:', error);
      throw error;
    }
  }
}
